var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSplitSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "36px",
    viewBox: "0 0 35 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "button/split arrow/hover copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "May-17",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Heatmap-display---View-and-Export",
    transform: "translate(-1356.000000, -4163.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button/split-arrow/hover-copy",
    transform: "translate(1356.000000, 4163.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.99921059,0 C1.34279232,0 0,1.34553934 0,3.00741988 L0,32.9925801 C0,34.6535323 1.35059566,36 2.99921059,36 L35,36 L35,0 L2.99921059,0 Z",
    id: "bg",
    fill: "#5697B7",
    transform: "translate(17.500000, 18.000000) rotate(180.000000) translate(-17.500000, -18.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chevron-down-default",
    transform: "translate(14.000000, 16.000000)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Chevron",
    points: "0 0 3.5 3 7 0"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSplitSelected);
export default __webpack_public_path__ + "static/media/icon_split_selected.fc4ee34f66a1cc704329b48c093fd52a.svg";
export { ForwardRef as ReactComponent };